import focusElement from './focus-element';
import {delegate} from './events';

export default function init(excludeSelector = '.smooth-off', options = {
    behavior: 'smooth'
}) {
    document.addEventListener('click', delegate('a[href^="#"]', function (e) {
        if (this.matches(excludeSelector)) {
            return;
        }
        const id = this.href.substring(this.href.indexOf('#') + 1);
        if (!id) {
            return;
        }
        const target = document.getElementById(id);
        if (!target) {
            return;
        }
        e.preventDefault();
        focusElement.call(target, true);
        target.scrollIntoView(options);
    }));
}